import React from 'react';
import { History } from 'history';
import { InputEmail } from '../../components';
import BaseCreate from '../base/base-create.component'; 
import Model from './user-model';  //editable..

interface IProps { 
    history: History;
    caption?: string;
    useremail?: string;
    disableBackButton?: boolean;
    disableCard?: boolean;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class UserAuthSendConfirmationEmail extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onError = (data: any) => {
        this.setState({errors: data});
    }

    private onSave = (data: any) => {
        var sent = data.sent; //triger for send useremail.
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    public componentDidMount(){
        this.setState({datarow: Model.defaultValueSendEmailConfirmation as any})
    }
    
    public componentDidUpdate(){
        if (!this.state.datarow.useremail && this.props.useremail!=='' && this.props.useremail!==this.state.datarow.useremail) 
            this.setState({ datarow: { ...this.state.datarow, 'useremail': this.props.useremail || '', 'email': Model.getEmailApp(this.props.useremail || '')}});
    }

    render() {
        return (
            //editable..          
            <BaseCreate history={this.props.history} caption={this.props.caption || 'Send Confirmation Email'} buttonCaption='Send Email'
                endPoint={Model.endPointAuth+ '/send-useremail-confirmation'} model={Model} datarow={this.state.datarow} validations={Model.validationSendEmailConfirmation} onError={this.onError} onSave={this.onSave} buttonOnBottom disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}>              
    
                <InputEmail id='senduseremail' name='useremail' label='Enter Registered Email' value={this.state.datarow.useremail} error={this.state.errors?.useremail} onChange={this.onChange} />
            </BaseCreate>
        );
    }     
     
}